import React from 'react'
import PropTypes from 'prop-types'
import {Grid, Box, Link as NavLink} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'
import Banner from './partials/banner'
import Video from './partials/video'
import PDComponent from '../../pd-component'
import {PD_HERO_XX_VALUE_BADGE} from '../../../../constants'
import Link from '../../../link'

export const PromoGridItem = ({
    regions,
    variant,

    desktopImage,
    mobileImage,
    imageAlt,

    desktopVideo,
    mobileVideo,
    desktopVideoThumbnail,
    mobileVideoThumbnail,
    videoAlt,
    videoEnableSound,
    videoDisableAutoPlay,

    desktopMediaBackground,
    mobileMediaBackground,
    overlayLink
}) => {
    const shouldDisplayVideo = (desktopVideo || mobileVideo) && !(desktopImage || mobileImage)

    const promotionComponents =
        regions?.filter(
            (region) => region?.id === 'heroPromotions' && region?.components?.length > 0
        )?.[0]?.components || []
    const calloutsComponents =
        regions?.filter(
            (region) => region?.id === 'customFlagsCallouts' && region?.components?.length > 0
        )?.[0]?.components || []
    const hasXXValueBadge = calloutsComponents.some(
        (component) => component?.typeId === PD_HERO_XX_VALUE_BADGE
    )
    const mainAreaPadding =
        calloutsComponents.length > 0 && variant === 'promoGridTwoItems'
            ? hasXXValueBadge
                ? {paddingY: {base: '110px', md: 0}}
                : {paddingY: {base: '70px', md: 0}}
            : {}
    const overlayRedirectionProps =
        overlayLink?.indexOf('https') === -1
            ? {to: overlayLink, isExternal: false, as: RouteLink}
            : {to: overlayLink, isExternal: true, as: NavLink}
    return (
        <Grid
            background={{base: mobileMediaBackground, md: desktopMediaBackground}}
            className="promo-grid-item"
            position="relative"
            templateColumns="1fr"
            templateRows="1fr"
            templateAreas={`"main"`}
            height="100%"
        >
            <Box gridArea="main" position="relative" className="promo-grid-item__media">
                {shouldDisplayVideo ? (
                    <Video
                        desktopVideo={desktopVideo}
                        mobileVideo={mobileVideo || desktopVideo}
                        desktopVideoThumbnail={desktopVideoThumbnail}
                        mobileVideoThumbnail={mobileVideoThumbnail}
                        videoDisableAutoPlay={videoDisableAutoPlay}
                        videoEnableSound={videoEnableSound}
                        videoAlt={videoAlt}
                        variant={variant}
                        desktopMediaOverlay={overlayLink}
                        mobileMediaOverlay={overlayLink}
                    />
                ) : desktopImage || mobileImage ? (
                    <Banner
                        desktopImage={desktopImage}
                        mobileImage={mobileImage}
                        imageAlt={imageAlt}
                        variant={variant}
                        desktopMediaOverlay={overlayLink}
                        mobileMediaOverlay={overlayLink}
                    />
                ) : null}

                {overlayLink && (
                    <Link
                        position="absolute"
                        top="0"
                        left="0"
                        right="0"
                        zIndex="1"
                        bottom="0"
                        {...overlayRedirectionProps}
                        className="promo-grid-item__overlay promo-grid-item__overlay"
                    />
                )}
            </Box>

            <Box
                gridArea="main"
                position="relative"
                {...mainAreaPadding}
                className="promo-grid-item__content"
            >
                {promotionComponents?.map((component, index) => (
                    <PDComponent
                        key={`promotion-${index}`}
                        component={component}
                        variant={variant}
                        className="promo-grid-item__promotion"
                    />
                ))}
            </Box>

            {calloutsComponents.map((component, index) => (
                <PDComponent
                    key={index}
                    component={component}
                    variant={variant}
                    className="promo-grid-item__callout"
                />
            ))}
        </Grid>
    )
}

PromoGridItem.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.shape({
                        question: PropTypes.string,
                        answer: PropTypes.string
                    })
                })
            )
        })
    ).isRequired,
    variant: PropTypes.string,

    desktopImage: PropTypes.string,
    mobileImage: PropTypes.string,
    imageAlt: PropTypes.string,

    desktopVideo: PropTypes.string,
    mobileVideo: PropTypes.string,
    desktopVideoThumbnail: PropTypes.string,
    mobileVideoThumbnail: PropTypes.string,
    videoAlt: PropTypes.string,
    videoEnableSound: PropTypes.bool,
    videoDisableAutoPlay: PropTypes.bool,

    desktopMediaBackground: PropTypes.string,
    mobileMediaBackground: PropTypes.string,
    overlayLink: PropTypes.string
}

export default PromoGridItem
